import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";

import { SharedMethods } from '../../../../util/sharedMethods-service';
import { Reglement } from '../../model/reglement';
import { Subject } from 'rxjs';


@Injectable()
export class ReglementService {

  iSconnecting: boolean = false;

  // saveReglementEvent = new Subject<any>();

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              public sharedMethods: SharedMethods,
              ) { }


  saveReglement(reglement: Reglement) {

      this.iSconnecting = true;
      let idSession = null;

      if (reglement.cashsession !== undefined && reglement.cashsession !== null)
      idSession = reglement.cashsession.id;

      let idfac: number;

      if ( reglement.facture !== undefined) {
        idfac = reglement.facture.id;
      } else {

        if ( reglement.id_facture !== undefined && reglement.id_facture !== null)
        idfac = reglement.id_facture;
      }

      const reg = {
        natureReglement: reglement.nature_reglement,
        facture: idfac,
        createBy: null,
        dateFlux: this.sharedMethods.converStringToDatetime(reglement.date_flux),
        typeFlux: reglement.type_flux,
        montant: reglement.montant,
        cashstate: idSession,
      };


      if (reglement.id !== 0) {

        return new Promise<Reglement>(resolve => {
          this.http.put(this.apiEndpoints.GET_URL_PUT_REGLEMENT(reglement.id), reg,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Reglement) => {
                resolve(data);
                this.iSconnecting = false;
              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSconnecting = false;
              });
        });

      }else {

        return new Promise<Reglement>(resolve => {
          this.http.post(this.apiEndpoints.GET_URL_POST_REGLEMENT, reg,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Reglement) => {
                resolve(data);
                this.iSconnecting = false;
              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSconnecting = false;
              });
        });

      }



    }

    deleteReglement(reglement: Reglement) {
      this.iSconnecting = true;
      return new Promise(resolve => {
        this.http.delete(this.apiEndpoints.GET_URL_DELETE_REGLEMENT(reglement.id),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe(data => {
              resolve(data);
              this.iSconnecting = false;
            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });


    }

}
